import { addToCatalogue, removeFromCatalogue } from '../services/catalogue.service';
import { FAVOURITES_EVENTS } from './favourites_state';

const ADD_TO_CATALOGUE = 'ADD_TO_CATALOGUE';
const ADDED_TO_CATALOGUE = 'ADDED_TO_CATALOGUE';
const REMOVE_FROM_CATALOGUE = 'REMOVE_FROM_CATALOGUE';
const REMOVED_FROM_CATALOGUE = 'REMOVED_FROM_CATALOGUE';
const ALL_PROPERTIES_REMOVED = 'ALL_PROPERTIES_REMOVED';

const events = [
  ADD_TO_CATALOGUE,
  ADDED_TO_CATALOGUE,
  REMOVE_FROM_CATALOGUE,
  REMOVED_FROM_CATALOGUE,
  ALL_PROPERTIES_REMOVED,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(ADD_TO_CATALOGUE, ({ id, csrfToken }) => {
    addToCatalogue({
      id,
      csrfToken,
      onResponse: ({ status, data }) => {
        if (status === 201) {
          const property = data;
          EVENT_BUS.dispatch(ADDED_TO_CATALOGUE, {
            property,
          });
          EVENT_BUS.dispatch(FAVOURITES_EVENTS.ADDED_TO_FAVOURITES, {
            id,
          });
          const { seconds_to_closing, seconds_to_auction_start } = data;
          if (seconds_to_auction_start < 0 && seconds_to_closing > 0) {
            window.location.href = '/auction-registration/your-properties';
          }
        }
      },
      onError: (err) => console.warn(err),
    });
  });

  EVENT_BUS.on(
    REMOVE_FROM_CATALOGUE,
    ({ id, myCatalogueRemove = false, csrfToken }) => {
      removeFromCatalogue({
        id,
        csrfToken,
        myCatalogueRemove,
        onResponse: ({ status, data }) => {
          if (status === 202) {
            EVENT_BUS.dispatch(REMOVED_FROM_CATALOGUE, { id, data });
            if ($.isEmptyObject(data.totalDeposit)) {
              EVENT_BUS.dispatch(ALL_PROPERTIES_REMOVED);
            }
          }
        },
        onError: (err) => console.warn(err),
      });
    }
  );
};

export const CATALOGUE_EVENTS = {
  ADD_TO_CATALOGUE,
  ADDED_TO_CATALOGUE,
  REMOVE_FROM_CATALOGUE,
  REMOVED_FROM_CATALOGUE,
  ALL_PROPERTIES_REMOVED,
  initializeEventListeners,
};
